module.exports = __webpack_public_path__ + "img/17-3-zh.a56595b1.jpg";